










import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import VoteList from './components/VoteList.vue';
import Title from './components/Title.vue';
import { Skeleton, Dialog } from 'vant';
import { isWeiXin } from '@/common/ts/common';
Vue.use(Skeleton).use(Dialog);
@Component({
  components: {
    VoteList,
    Title,
  },
})
export default class Two extends Vue {
  loading: boolean = true;
  option = config.OPTHINES;
  downLoadUrl: string =
    'http://a.app.qq.com/o/simple.jsp?pkgname=com.news.shangyounews';
  enterPage() {
    if (window.udid) {
      this.$router.push({ path: './Selection', query: { type: 'Two' } });
    } else {
      console.log('object');
      Dialog.confirm({
        title: '友情提示',
        message: '请在上游新闻App进行投票',
        confirmButtonText: '还没装？一步安装',
        cancelButtonText: '我已安装过',
        closeOnClickOverlay: true,
      })
        .then(() => {
          window.location.href = this.downLoadUrl;
        })
        .catch(() => {
          window.location.href =
            'shangyounews://{"dt":"7","url":"' + document.location.href + '"}';
        });
    }
  }
}
